/* DashboardRenderer.js */

"use strict";

/**
 *
 * @class DashboardRenderer
 */
class DashboardRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = this._createRootElement("dashboard-section");

        this.title = "Dashboard";

        this._registerListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();

        return (
            Promise.all([])
                .then(() => {
                    this._model = undefined;
                    this._rootElem = undefined;
                })
                // eslint-disable-next-line no-console
                .catch(console.error.bind(console, `${this.constructor.name} shutdown error: `))
        );
    }

    render() {
        const root = document.createElement("main");
        // const widgetsContainer = document.createElement("section");
        // widgetsContainer.className = "widgets-container";
        // widgetsContainer.innerText = "someWidgets are here";
        //
        // root.innerHTML = `
        //     <header>
        //         <h1>${this.title}</h1>
        //     </header>
        // `;
        // root.appendChild(widgetsContainer);

        let userInfo = this._model._userSession.getUser();
        let userAuthenticated = this._model._userSession.isConnectedAndAuthenticated();
        let actions = userInfo.authorizedActions;
        if (!userInfo || !userAuthenticated) {
            return new Promise((resolve /*,reject*/) => {
                resolve(false);
            });
        }
        if (!actions.includes("dashboardAccess")) {
            this._model._router.goTo({
                app: "GameConsole",
                s: "GameCenter",
                sln: "DeviceManager",
                exp: "device"
            });
            return new Promise((resolve /*,reject*/) => {
                resolve(false);
            });
        }
        // Run react app
        if (typeof window.startReactApp === "function") {
            window.startReactApp();
        }
        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(root);
            resolve();
        });
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _createRootElement(rootClassName = "") {
        const rootElement = document.createElement("div");
        rootElement.classList.add(rootClassName);
        rootElement.component = this._model;
        rootElement.id = "gluware-react-app";
        return rootElement;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = DashboardRenderer;
